import { ApolloError } from '@apollo/client'
import { SWIPER_ERRORS } from './constants'

const ERR_CODE_UNACCEPTABLE_AMOUNT = '1402'
const ERROR_CODE_NEGATIVE_AMOUNT = '1403'
const ERR_CODE_NOT_FOUND_PAYMENT_TYPE = '1302'
const ERR_CODE_GET_PAIRINGS_FAILED = '130000'
const ERR_CODE_NO_PAIRING_FOUND = '130008'
const ERR_CODE_PROVIDER_REFUND_EXCEEDED_TRANS_AMOUNT = '180002'
const ERR_CODE_NOT_AVAILABLE_STATUS = '130010'
const ERR_CODE_ECONDUIT = '190000'

export const getSwiperErrorCode = (error?: ApolloError) => {
  const errorCode = error?.graphQLErrors?.[0]?.extensions?.error_code
  if (!errorCode) {
    return SWIPER_ERRORS.UNKNOWN
  }

  switch (errorCode.toString()) {
    case ERR_CODE_NOT_FOUND_PAYMENT_TYPE:
    case ERR_CODE_GET_PAIRINGS_FAILED:
    case ERR_CODE_NO_PAIRING_FOUND: {
      return SWIPER_ERRORS.NO_TERMINAL
    }
    case ERR_CODE_UNACCEPTABLE_AMOUNT: {
      return SWIPER_ERRORS.INVALID_AMOUNT_INPUT
    }
    case ERROR_CODE_NEGATIVE_AMOUNT: {
      return SWIPER_ERRORS.INVALID_NEGATIVE_AMOUNT_INPUT
    }
    case ERR_CODE_PROVIDER_REFUND_EXCEEDED_TRANS_AMOUNT: {
      return SWIPER_ERRORS.OVER_REFUND
    }
    case ERR_CODE_NOT_AVAILABLE_STATUS: {
      return SWIPER_ERRORS.UNAVAILABLE_REVERSAL_STATUS
    }
    case ERR_CODE_ECONDUIT: {
      return SWIPER_ERRORS.ECONDUIT_ERROR
    }
    default: {
      return SWIPER_ERRORS.UNKNOWN
    }
  }
}

// helper to throw server-driven errors
export class ServerDrivenError extends Error {
  public code: string
  constructor(code: string) {
    super('Error in the server-driven flow')
    this.code = code
  }
}
